'use strict';

const scheduleElement = function(id, start, end) {
    const startTime = new Date(start);
    const endTime = new Date(end);
    const now = new Date();
    const elementId = id;

    if (startTime >= now || now >= endTime) {
    document.getElementById(elementId).classList.add('hidden');
    }
}